import { deleteForeverContentsAction } from '~src/spacesPlatform/actions/DeleteForeverContentAction';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { IDeleteForeverAction as IDeleteForeverActionApi } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { isRecycleBinSpace } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const DeleteForeverAction: IEntityAction<IContentInfo, IDeleteForeverActionApi> = {
  name: EntityActionNames.DeleteForever,
  translateName: Messages.deleteForeverAction,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isRecycleBinSpace(state.spaceInfo);
  },
  isClickable: (availableActions: IDeleteForeverActionApi, targetItems: IContentInfo[]) => {
    // Check if any of the target items are read-only archived content
    const hasReadOnlyContent = targetItems.some(item => item.isArchivedReadOnly);

    // Leaving off availableActions.delForever check since this should always
    // be enabled when in the Recycle Bin space (the isVisible criteria)
    return !!(availableActions) && !hasReadOnlyContent;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return deleteForeverContentsAction(targetItems);
  },
};